var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnowledgebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00813 0C4.041 0 0 4.041 0 9.00813V49.1317H12.8733L15.5023 25.9688L12.8733 0L9.00813 0Z",
    fill: "#5EB16A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9192 0H12.873V49.1315L48.9192 39.8776V0Z",
    fill: "#009B5C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0284 42.0415C7.00713 42.0415 3.74707 45.3014 3.74707 49.3229C3.74707 49.3929 3.75035 49.4622 3.7524 49.5316C3.86328 53.4562 7.07713 56.6041 11.0284 56.6041H12.8736V42.0415H11.0284Z",
    fill: "#F7FCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5196 17.737H21.2734V8.23096H40.5196V17.737Z",
    fill: "#ECF3FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.304 49.5377C43.304 49.5356 43.3042 49.5336 43.3042 49.5316C43.3076 46.4743 45.7983 43.9882 48.9192 43.9882L45.5399 42.0415H12.873V56.6041H46.5785L48.9192 55.0812C45.7963 55.0812 43.304 52.5977 43.304 49.5377Z",
    fill: "#ECF3FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3518 49.5317C43.3524 48.7918 43.4859 48.0858 43.7255 47.4399H12.873V51.5508H43.6951C43.4741 50.9263 43.3516 50.2477 43.3516 49.5379C43.3516 49.5358 43.3518 49.5338 43.3518 49.5317Z",
    fill: "#E0E6F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.11086 49.5317C4.11086 46.4749 6.59764 43.9883 9.65426 43.9883H12.8733L14.2625 42.0416L12.8733 39.8774H9.65426C4.33084 39.8774 0 44.2083 0 49.5317C0 54.8551 4.33084 59.186 9.65426 59.186H12.8733L14.2625 57.7698L12.8733 55.0758L9.65426 55.0752C6.59764 55.0751 4.11086 52.5883 4.11086 49.5317Z",
    fill: "#89CE6D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.873 39.8774H48.9192V43.9883H12.873V39.8774Z",
    fill: "#5EB16A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9192 59.1863V55.0816L12.873 55.0762V59.1863H48.9192Z",
    fill: "#5EB16A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0998 23.7134C30.7563 23.7134 27.2227 27.247 27.2227 31.5906V61.2075H38.4798L40.7787 40.9527L38.4798 23.7134H35.0998Z",
    fill: "#FDD752"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0001 23.7134H38.4795V61.2075L70.0001 53.1154V23.7134Z",
    fill: "#F8BD3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8662 55.0078C33.3496 55.0078 30.499 57.8585 30.499 61.3749C30.499 61.4362 30.5019 61.4968 30.5037 61.5576C30.6006 64.9894 33.411 67.7422 36.8662 67.7422H38.4796V55.0078H36.8662Z",
    fill: "#FFF7E7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0899 61.5629C65.0899 61.5612 65.09 61.5594 65.09 61.5576C65.093 58.8842 67.2711 56.7101 70.0001 56.7101L67.0451 55.0078H38.4795V67.7422H67.9533L70.0001 66.4104C67.2693 66.4104 65.0899 64.2388 65.0899 61.5629Z",
    fill: "#FFE6CE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0908 61.5575C31.0908 58.8845 32.9919 57.0957 35.6649 57.0957H38.4798L39.6946 55.0077L38.4798 53.1152H35.6649C31.0099 53.1152 27.2227 56.9023 27.2227 61.5575C27.2227 66.2126 31.0099 69.9997 35.6649 69.9997H38.4798L39.6946 68.7613L38.4798 65.9932L35.6649 65.9926C32.9919 65.9926 31.0908 64.2305 31.0908 61.5575Z",
    fill: "#FEE386"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4795 53.1152H70.0001V57.0957H38.4795V53.1152Z",
    fill: "#FDD752"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0001 70V65.9985L38.4795 65.9932V70H70.0001Z",
    fill: "#FDD752"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9766 43.6543H61.2366V47.76H47.9766V43.6543Z",
    fill: "#FDD752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgebase);
export default __webpack_public_path__ + "static/media/knowledgebase.5612c6068cf496839adee4f636d98142.svg";
export { ForwardRef as ReactComponent };